<div
  *ngIf="user"
  class="flex align-items-center">
  <crm-user-avatar [user]="user"></crm-user-avatar>
  <div class="ml-2">
    <div class="font-medium">
      <ng-container>{{ user?.profile?.name }}</ng-container>
    </div>
    <div class="text-sm text-400">
      <ng-container>{{ user?.job }}</ng-container>
    </div>
    <div
      *ngIf="user?.banned"
      class="font-medium text-red-500">
      (Заблокирован)
    </div>
  </div>
</div>
